var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('div',{staticClass:"nav-bar"},[_c('button',{staticClass:"btn btn-link pb-0 px-0",on:{"click":function($event){return _vm.$emit('back')}}},[_c('span',{staticClass:"lnr lnr-chevron-left mr-2"}),_c('span',[_vm._v("ย้อนกลับ")])])]),_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.terms)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }